import { useEffect, useState } from "react";
import { api } from "../lib/api";
import AppShell from "../components/AppShell";
import { History, Loader2 } from "lucide-react";

const NAV = [
  {to:"/founder/dashboard",label:"Dashboard"},
  {to:"/founder/tutorial",label:"Tutorial"},
  {to:"/founder/team",label:"Team"},
  {to:"/onboarding",label:"Onboarding"},
];

const fmt = (iso) => {
  try {
    return new Date(iso).toLocaleString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
};

export default function FounderActivity() {
  const [entries, setEntries] = useState(null);
  useEffect(() => {
    api.get("/founder/audit-log")
      .then((r) => setEntries(r.data?.entries || []))
      .catch(() => setEntries([]));
  }, []);

  return (
    <AppShell nav={NAV}>
      <div className="mx-auto w-full max-w-3xl pb-32" data-testid="founder-activity-page">
        <h1 className="flex items-center gap-2 text-2xl font-bold tracking-tight text-neutral-900">
          <History className="h-6 w-6 text-[#0A8B85]" /> Account activity
        </h1>
        <p className="mt-1 text-sm text-neutral-600">
          Everything that happened in your account — whether by you or an advisor managing it on your behalf.
        </p>
        <div className="mt-6 overflow-hidden rounded-2xl border border-neutral-200 bg-white">
          {entries === null ? (
            <p className="flex items-center gap-2 p-5 text-sm text-neutral-500"><Loader2 className="h-4 w-4 animate-spin" /> Loading…</p>
          ) : entries.length === 0 ? (
            <p className="p-6 text-center text-sm text-neutral-500" data-testid="activity-empty">No activity recorded yet.</p>
          ) : (
            <ul className="divide-y divide-neutral-100">
              {entries.map((e, i) => (
                <li key={i} className="flex flex-wrap items-baseline gap-x-3 gap-y-0.5 px-5 py-3 text-sm" data-testid={`activity-row-${i}`}>
                  <span className="w-40 shrink-0 text-xs text-neutral-400">{fmt(e.at)}</span>
                  <span className={"shrink-0 rounded-full px-2 py-0.5 text-[10px] font-bold " +
                    (e.actor === "Founder" ? "bg-[#0A8B85]/10 text-[#0A8B85]" : "bg-purple-100 text-purple-700")}>
                    {e.actor}
                  </span>
                  <span className="text-neutral-800">{e.action}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </AppShell>
  );
}
